import * as React from 'react';
import { AnyObject } from 'final-form';
import { Page, Text, Document, StyleSheet, View } from '@react-pdf/renderer';
import PropertyUtil from 'src/util/PropertyUtil';
import moment from 'moment';
// import SignatureBlockManager from './SignatureBlockManager';
import Acknowledgement from 'src/models/leasing/Acknowledgement';
import SignatureBlock from 'src/models/leasing/SignatureBlock';
import LeaseClauseType from 'src/models/LeaseClauseType';
import LocationModel from 'src/models/leasing/LocationModel';
import ContractAdHocClause from '../../redesign/ContractGenerationModels/ContractAdHocClause';
import ContractAddendumClause from '../../redesign/ContractGenerationModels/ContractAddendumClause';
import IContract from 'src/models/contract_types/IContract';

const styles = StyleSheet.create({
    page: {
        backgroundColor: '#FFFFFF',
        padding: '1in',
        fontFamily: 'Times-Roman',
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 10,
        color: '#8e9094',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    bold: {
        fontFamily: 'Times-Bold',
    },
    fontNormal: {
        fontSize: '11pt',
        lineHeight: 1.25,
    },
    mt1: {
        marginTop: 10,
    },
    mt2: {
        marginTop: 20,
    },
    mt3: {
        marginTop: 30,
    },
    mt4: {
        marginTop: 40,
    },
    center: {
        textAlign: 'center',
    },
    text: {
        textAlign: 'justify',
    },
    sbTitle: {
        textAlign: 'center',
        marginBottom: 10,
    },
    underlined: {
        textDecoration: 'underline',
    },
    indent: {
        fontFamily: 'Times-Italic',
    },
    mailingInfo: {
        fontSize: 10,
        fontFamily: 'Times-Roman',
    },
    acknowledgementHeading: {
        textAlign: 'center',
        fontSize: '14pt',
        fontWeight: 'bold',
    },
    exhibitHeading: {
        textAlign: 'center',
        fontSize: '12pt',
        fontWeight: 'bold',
    },
    leaseHeading: {
        textAlign: 'center',
        fontSize: '11pt',
        fontFamily: 'Times-Bold',
    },
    doubleLines: {
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
    },
    h2: {
        fontSize: 14,
    },
    firstLvl: {
        marginLeft: '0.5in',
    },
    secondLvl: {
        marginLeft: '1in',
    },
    thirdLvl: {
        marginLeft: '1.5in',
    },
    fourthLvl: {
        marginLeft: '2in',
    },
});

export interface IPalladiumEnergyStateProps {
    contractData: IContract;
    contractAddendumClauses?: ContractAddendumClause[];
    contractClauseTypes?: LeaseClauseType[];
    locationData?: LocationModel;
}

export default class PalladiumEnergy extends React.Component<IPalladiumEnergyStateProps> {
    private additionalProvisionNumber = 0;

    additionalProvisions = () => {
        let renderClauses: ContractAddendumClause[] = [];
        this.props.contractData.contractClauses.forEach((llc: AnyObject, index: number) => {
            let clause: ContractAddendumClause = !!this.props.contractAddendumClauses
                ? this.props.contractAddendumClauses.find((lc) => lc.id === llc.contractAddendumClauseId)
                : undefined;

            if (!!clause) {
                renderClauses.push(clause);
            }
        });

        return renderClauses?.map((rc: ContractAdHocClause, index: number) => {
            this.additionalProvisionNumber++;
            return (
                <Text key={index} style={[styles.fontNormal, styles.mt2, styles.text]}>
                    {this.additionalProvisionNumber}) {`${rc.leaseClauseTypeId}: ${rc.clauseText}`}
                </Text>
            );
        });
    };

    adhocProvisions = () => {
        const adHocClauses = this?.props?.contractData?.adHocClauses;
        if (adHocClauses?.length > 0) {
            return this.props?.contractData?.adHocClauses?.map((lc: ContractAdHocClause, index: number) => {
                let type: string = !!this.props?.contractClauseTypes
                    ? this.props?.contractClauseTypes?.find((lct) => lct.id === lc.leaseClauseTypeId)?.name
                    : '';

                this.additionalProvisionNumber++;
                return (
                    <Text key={index} style={[styles.fontNormal, styles.mt2, styles.text]}>
                        {this.additionalProvisionNumber}) {`${type}: ${lc.clauseText}`}
                    </Text>
                );
            });
        }
        return <div />;
    };

    displaySignatureBlocks = () => {
        return this.props?.contractData
            ? this.props?.contractData?.acknowledgements?.map((la: Acknowledgement) => {
                  return (
                      la.signatureBlocks.length > 0 &&
                      la.signatureBlocks.map((sb: SignatureBlock, index: number) => {
                          return (
                              <View key={index} wrap={false}>
                                  <Text style={[styles.fontNormal, styles.mt2, styles.text]}>LESSOR:</Text>
                                  <Text style={[styles.fontNormal, styles.mt2, styles.text]}>______________________________________________</Text>
                                  <Text style={[styles.fontNormal, styles.mt1, styles.text]}>{sb.ownerName}</Text>
                              </View>
                          );
                      })
                  );
              })
            : [];
    };

    displayAcknowledgements = () => {
        return this.props?.contractData
            ? this.props?.contractData?.acknowledgements?.map((la: Acknowledgement, index: number) => {
                  return (
                      <View key={index} wrap={false}>
                          <Text style={[styles.fontNormal, styles.mt3, styles.text]}>{la.text}</Text>
                      </View>
                  );
              })
            : [];
    };

    // signatureBlocks = (leaseValues: AnyObject) => {
    //     return <SignatureBlockManager leaseValues={leaseValues} styles={styles} />;
    // };

    // tslint:disable: max-line-length
    render() {
        const rowValues = PropertyUtil.SafeGet(() => this.props.contractData);
        // const firstIncludedTract = rowValues?.tracts?.find((tract: AnyObject) => tract.includeTract === true);
        // const totalGrossAcres = rowValues?.tracts?.reduce((acc: number, tract: AnyObject) => {
        //     if (tract.includeTract === true) {
        //         let tempGrossAcres = parseFloat(tract.grossAcres) || 0;
        //         return acc + tempGrossAcres;
        //     } else {
        //         return acc;
        //     }
        // }, 0);

        return (
            <Document>
                <Page size="LEGAL" style={styles.page}>
                    {/* <Text style={styles.mailingInfo}>After recording return to:</Text>
                    <Text style={styles.mailingInfo}>{PropertyUtil.SafeGet(() => rowValues.lesseeName, 'LESSEE NAME')}</Text>
                    <Text style={styles.mailingInfo}>{PropertyUtil.SafeGet(() => rowValues.lesseeAddressLine1, 'ADDRESS')}</Text>
                    <Text style={styles.mailingInfo}>{PropertyUtil.SafeGet(() => rowValues.lesseeAddressLine2, '')}</Text>
                    <Text style={styles.mailingInfo}>
                        {PropertyUtil.SafeGet(
                            () => rowValues.lesseeCity + ', ' + rowValues.lesseeState + ' ' + rowValues.lesseeZipCode,
                            'CITY, STATE, ZIP'
                        )}
                    </Text> */}

                    <Text style={[styles.leaseHeading, styles.underlined, styles.bold]}>WAIVER OF SURFACE RIGHTS</Text>

                    <Text style={[styles.fontNormal, styles.mt2, styles.text]}>
                        This Waiver of Surface Rights (this <Text style={[styles.indent]}>“Agreement”</Text>) is made and entered into as of{' '}
                        {PropertyUtil.SafeGet(() => moment(rowValues.effectiveDate).format('Do'), 'DAY')} day of{' '}
                        {PropertyUtil.SafeGet(() => moment(rowValues.effectiveDate).format('MMMM'), 'MONTH')},{' '}
                        {PropertyUtil.SafeGet(() => moment(rowValues.effectiveDate).format('YYYY'), 'YEAR')} (the{' '}
                        <Text style={[styles.indent]}>“Effective Date”</Text>), by and between{' '}
                        {PropertyUtil.SafeGet(() => rowValues.ownersOnDocument, 'LESSOR NAME')} (the{' '}
                        <Text style={[styles.indent]}>“Mineral Owner”</Text>), and {PropertyUtil.SafeGet(() => rowValues.lesseeName, 'LESSEE NAME')}{' '}
                        (the <Text style={[styles.indent]}>“Company”</Text>) on the other. The Mineral Owner and the Company may be referred to herein
                        individually as a “Party” and collectively as “Parties”. The Parties agree as follows:
                    </Text>

                    {/* <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        WHEREAS, {PropertyUtil.SafeGet(() => rowValues.ownersOnDocument, 'LESSOR NAME')} owns certain mineral rights ("Mineral
                        Interest") under certain tracts of land in {!!this.props.locationData && this.props.locationData?.counties[0]} County,{' '}
                        {!!this.props.locationData && this.props.locationData?.state}, being more particularly described in Exhibit A attached hereto
                        and made a part of this Agreement ("Premises"); and
                    </Text> */}
                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        WHEREAS, the Company has proposed to locate a solar energy project on all or a part of the surface of certain real property
                        (the <Text style={[styles.indent]}>“Property”</Text>) defined in Exhibit A hereto (the “Solar Farm”);
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        WHEREAS, the Mineral Owner owns all of a portion of the Mineral Rights (as defined in Section 1 d.) in, on, and under the
                        Property; and
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        WHEREAS, the Company desires to obtain a waiver of the Mineral Owner’s Surface Rights (as defined in Section 1 f.) and the
                        Mineral Owner desires to waive such rights.
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        NOW THEREFORE, for and in consideration of the sum to be paid by the Company to the Mineral Owner, as set forth in Exhibit B
                        of this Agreement, as well as the warranties, covenants, representations, and other obligations undertaken by the Parties
                        hereunder the Parties hereby agree and bind themselves as follows:
                    </Text>

                    <View
                        style={[
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            1.{'    '}
                            <Text style={[styles.bold, styles.underlined]}>Definitions:</Text> Unless otherwise defined in this Agreement, the
                            following terms shall have the meaning set forth in this Section 1.
                        </Text>
                    </View>

                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            a.{'    '}
                            <Text style={[styles.indent]}>Agreement - </Text>this Waiver of Surface Rights and all exhibits attached hereto.
                        </Text>
                    </View>

                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            b.{'    '}
                            <Text style={[styles.indent]}>Environmental Laws - </Text>means any federal, state or local law, code, statute, ordinance,
                            rule, regulation, rule of common law, guideline or informal policy position, relating to or imposing liability or
                            standards of conduct concerning any hazardous, toxic or dangerous waste, substance or material; or any substances or
                            mixture of any Hazardous Materials regulated thereunder (collectively, and including, without limitation, any such laws
                            which require notice of the use, presence, storage, generation, disposal or release of any Hazardous Materials to be
                            provided to any party), including, but not limited to, the following: the Comprehensive Environmental Response,
                            Compensation and Liability Act, as now or hereafter amended (42 U.S.C. Section 9601, et seq.); the Hazardous Substances
                            Transportation Act, as now or hereafter amended (49 U.S.C. Section 1801, et seq.); the Resource Conservation and Recovery
                            Act, as now or hereafter amended (42 U.S.C. Section 6901, et seq.); and any so-called “Superfund” or “Superlien” law, or
                            any other federal, state or local statute, law, ordinance, code, rule, regulation, order or decree regulating, relating to
                            or imposing liability or standards of conduct concerning any hazardous, toxic or dangerous waste, substance or material;
                            or any substances or mixture regulated under the Toxic Substance Control Act of 1976, as now or hereafter amended (15
                            U.S.C. Section 2601 et seq.); and any “toxic pollutant” under the Clean Water Act, as now or hereafter amended (33 U.S.C.
                            Section 1251 et seq.); and any hazardous air pollutant under the Clean Air Act, as now or hereafter amended (42 U.S.C.
                            Section 7901 et seq.).
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            c.{'    '}
                            <Text style={[styles.indent]}>Harazdous Materials - </Text>means any hazardous or toxic substances, materials and wastes,
                            pollutants, and contaminants which are regulated or are classified as hazardous or toxic by any governmental authority
                            having jurisdiction over the Property, including, but not limited to, those substances included in the definitions of
                            hazardous substances, "hazardous materials," "Toxic Substances," "Hazardous Waste," "Solid Waste," "Pollutant," or
                            "Contaminant" in any applicable federal, state, local or other applicable law pertaining to public or worker health,
                            welfare or safety or the environment. attached hereto.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            d.{'    '}
                            <Text style={[styles.indent]}>Mineral Rights - </Text>the oil, gas, and other minerals in, on, under, or that may be
                            produced from the Property, howsoever drilled, mined or produced. attached hereto.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            e.{'    '}
                            <Text style={[styles.indent]}>Solar Lease - </Text>that certain Ground Lease Agreement entered into on the __ day of
                            _______, 20__ by and between _____________________________, and _____________________, LLC as evidenced by that certain
                            Memorandum of Lease recorded on ____________________ and recorded in Year 20__, Instrument _______________ of the
                            ________________ public records.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            f.{'    '}
                            <Text style={[styles.indent]}>Surface Rights - </Text>the right of the Mineral Owner to enter upon or use the surface of
                            the Property for any purpose whatsoever, and the five hundred (500) feet of subsurface directly beneath the surface of the
                            Property, for any purpose whatsoever, including, but not limited to, conducting operations of whatever nature with respect
                            to exploring for, developing, drilling, producing, treating, storing or transporting oil, gas, and other minerals, or for
                            any other purpose incident thereto, together with all rights of ingress and egress to the surface of the Property in
                            connection with conducting operations of the Mineral Rights.
                        </Text>
                    </View>

                    <View
                        style={[
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            2.{'    '}
                            <Text style={[styles.bold, styles.underlined]}>Waiver:</Text> The Mineral Owner hereby waives their Surface Rights in and
                            to the Property for a period of time commencing on the Effective Date and for so long as the Company, or any successor or
                            assign, maintains the Solar Lease on the Property. For the avoidance of doubt, this Agreement shall automatically
                            terminate, and be of no further force or effect, if the Solar Lease terminates, expires, or otherwise is surrendered in
                            its entirety, and in each event at the sole determination of Company. Notwithstanding the foregoing, it is specifically
                            understood and agreed that Mineral Owner shall have the right to in all ways explore for, develop, and produce the Mineral
                            Rights from locations other than the surface of the Property.
                        </Text>
                    </View>

                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            a.{'    '}
                            <Text style={[styles.indent]}>Partial Termination of Solar Lease:</Text> If any of the lands comprising the Property are
                            released from the terms of the Solar Lease by Company, by and through a separate agreement then this Agreement shall
                            terminate to those lands released from the terms of the Solar Lease; however, this Agreement shall remain effective for
                            any lands still subject to the Solar Lease.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            b.{'    '}
                            <Text style={[styles.indent]}>Drill Zones:</Text> In the event Company places any drill zones or drill corridors, in which
                            any person or entity will have the right to drill for, explore, or otherwise develop any Mineral Rights then Mineral Owner
                            shall be entitled to use such drill zones or corridors. However, it is expressly understood and agreed that Company is
                            under no obligation to place any drill zones or corridors on the Property or in the Solar Farm as a result of this
                            Agreement. Further, if a drill zone does not exist as of the Effective Date herein, then such subsequent drill zone shall
                            be memorialized by a separate agreement which shall identify with specificity the size and location of the drill zone.
                        </Text>
                    </View>

                    <View
                        style={[
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            3.{'    '}
                            <Text style={[styles.bold, styles.underlined]}>Payment:</Text> Company shall pay Mineral Owner the amounts set forth on
                            Exhibit B attached hereto.
                        </Text>
                    </View>
                    <View
                        style={[
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            4.{'    '}
                            <Text style={[styles.bold, styles.underlined]}>Indemnity:</Text> Except to the extent the Mineral Owner does not own the
                            oil, gas, and other minerals under the Property, and except to the extent of parties claiming by or through the Mineral
                            Owner, Company shall defend, indemnify, and hold Mineral Owner harmless from and against any judgements, fines, losses,
                            damages, liabilities, costs, expenses, causes of actions, and lawsuits brought by any other person or entity claiming
                            ownership of all or a portion of the Mineral Rights beneath the Property, to the extent directly related to Company’s
                            operations on the Property or as a result of this Agreement.
                        </Text>
                    </View>
                    <View
                        style={[
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            5.{'    '}
                            <Text style={[styles.bold, styles.underlined]}>Warranty:</Text> Mineral Owner warrants and represents that (a) Mineral
                            Owner is the owner of the Mineral Rights; (b) Mineral Owner has the full and unrestricted power and authority to execute
                            and deliver this Agreement and to Waive their Surface Rights; (c) That Mineral Owner or any third-party have not brought
                            any Hazardous Materials onto the Property or contaminated the Property or subsurface of the Property with any Hazardous
                            Materials or otherwise violated any Environmental Laws; and (d) There are no leases, easements, or other agreements that
                            have been executed by Mineral Owner that relate to or grant any interest in or to the Mineral Rights (or any portion
                            thereof) to any third party. In the event any warranties or representations made and given under this Section were untrue
                            at the time given or otherwise becomes untrue, at any time after the Effective Date, then Mineral Owner shall indemnify,
                            defend, and hold Company harmless from and against any judgements, fines, penalties, losses, damages, liabilities, costs,
                            expenses, causes of actions, and lawsuits (including, without limitation, reasonable attorneys’ fees) related directly or
                            indirectly to any such warranty or representation being untrue and Company shall be entitled to a refund of any sums paid
                            to Mineral Owner pursuant to this Agreement (which shall be in addition to any other rights and remedies Company may be
                            entitled to pursuant to Section 6 of this Agreement).
                        </Text>
                    </View>
                    <View
                        style={[
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            6.{'    '}
                            <Text style={[styles.bold, styles.underlined]}>Remedies:</Text> The Parties shall have all rights and remedies at law or
                            in equity for any breach of this Agreement; provided, however, that as a precondition to exercising any such rights and
                            remedies the aggrieved Party shall give written notice to the offending Party of the alleged breach of this Agreement and
                            shall give the offending Party no less than sixty (60) days to cure such breach.
                        </Text>
                    </View>
                    <View
                        style={[
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            7.{'    '}
                            <Text style={[styles.fontNormal, styles.text, styles.bold, styles.underlined, { marginLeft: 16, width: '100%' }]}>
                                General Provisions:
                            </Text>
                        </Text>
                    </View>

                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            a.{'    '}
                            <Text style={[styles.indent]}>Notices:</Text> All notices, elections, demands, requests, payments and other communications
                            hereunder shall be in writing, signed by the party making the same and shall be sent by certified or registered United
                            States mail, postage prepaid, or by national overnight courier service which provides tracking and acknowledgement of
                            receipts, addressed to:
                        </Text>
                    </View>

                    <View style={[styles.thirdLvl, { marginTop: 10 }]}>
                        <View style={{ display: 'flex', marginLeft: 10 }}>
                            <View>
                                <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                                    To {PropertyUtil.SafeGet(() => rowValues.ownersOnDocument, 'LESSOR NAME')}:{' '}
                                </Text>
                            </View>
                            <View>
                                <Text style={[styles.fontNormal, styles.mt1, styles.text, { marginLeft: 3 }]}>
                                    {PropertyUtil.SafeGet(() => rowValues.ownersAddressOnDocument, 'LESSOR ADDRESS')}
                                </Text>
                            </View>
                        </View>
                        <View style={{ display: 'flex', marginLeft: 10 }}>
                            <View>
                                <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                                    To {PropertyUtil.SafeGet(() => rowValues.lesseeName, 'LESSEE NAME')}:{' '}
                                </Text>
                            </View>
                            <View>
                                <Text style={[styles.fontNormal, styles.mt1, styles.text, { marginLeft: 3 }]}>
                                    {PropertyUtil.SafeGet(
                                        () =>
                                            rowValues.lesseeAddressLine1 +
                                            ', ' +
                                            rowValues.lesseeCity +
                                            ', ' +
                                            rowValues.lesseeState +
                                            ', ' +
                                            rowValues.lesseeZipCode,
                                        'LESSEE ADDRESS'
                                    )}
                                </Text>
                            </View>
                        </View>
                    </View>

                    <Text style={[styles.fontNormal, styles.firstLvl, { marginTop: 15 }]} wrap={true}>
                        At such other address, as may hereafter be designated in writing by either Party hereto. The time and date on which mail is
                        postmarked shall be the time and date on which such communication is deemed to have been given.
                    </Text>

                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            b.{'    '}
                            <Text style={[styles.indent]}>Attorney Fees:</Text> If either Party brings any action or proceeding against the other
                            (including any cross-complaint, counterclaim or third party claim) to enforce or interpret this Agreement, or otherwise
                            arising out of this Agreement, the prevailing Party in such action or proceeding shall be entitled to recover its costs
                            and expenses of suit (including, without limitation, reasonable attorneys’ fees, accountants’ fees, consulting fees, court
                            costs and other legal expenses), and such amounts shall be payable whether or not such action or proceeding is prosecuted
                            to judgment.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            c.{'    '}
                            <Text style={[styles.indent]}>Further Assurance:</Text> The Parties agree to execute any further documents reasonably
                            necessary or desirable to effectuate the intent of the Parties to waive the Surface Rights of Mineral Owner in the manner
                            and according to the terms set forth herein; provided, however, that such further documents do not materially increase or
                            decrease the Parties’ obligations, covenants, or rights hereunder.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            d.{'    '}
                            <Text style={[styles.indent]}>Waiver:</Text> The waiver by any Party of any breach of any covenant or agreement herein
                            contained shall not be deemed to be a waiver of any subsequent breach of the same or any other covenant or agreement
                            herein contained.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            e.{'    '}
                            <Text style={[styles.indent]}>No Partnership:</Text> Nothing contained in this Agreement shall be deemed or construed by
                            the Parties or by any third person to create the relationship of principal and agent, partnership, joint venture or any
                            other association between Mineral Owner and Company.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            f.{'    '}
                            <Text style={[styles.indent]}>Choice of Law:</Text> This Agreement shall be governed and construed pursuant to Texas law
                            without regard to any choice of law principles and the state courts of the county where the Property is located shall have
                            exclusive venue for any disputes arising out of or under this Agreement and the Parties hereby expressly submit themselves
                            to the jurisdiction of such courts.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            g.{'    '}
                            <Text style={[styles.indent]}>Counterparts:</Text> This Agreement may be executed in any number of counterparts with the
                            same effect as if all signatory parties had signed the same document. All counterparts shall be construed together and
                            shall constitute one and the same instrument.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            h.{'    '}
                            <Text style={[styles.indent]}>Covenant Running with the Land / Succesors in Interest:</Text> This Agreement shall run with
                            the land and all terms, conditions and covenants of this Agreement and all amendments thereto shall extend to and bind the
                            Parties hereto and their respective heirs, legal representatives, successors, assigns, tenants and lessees.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            i.{'    '}
                            <Text style={[styles.indent]}>Incorporation of Exhibits:</Text> All exhibits attached to this Agreement are hereby
                            incorporated herein as though set forth in full in this Agreement.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            j.{'    '}
                            <Text style={[styles.indent]}>Construction:</Text> Each Party represents that they have the legal capacity to enter into
                            this Agreement and do so of their own free accord, without duress or coercion. The Parties further represent that this is
                            a fully negotiated agreement and each Party was represented by legal counsel or given the opportunity to consult legal
                            counsel prior to entering into this Agreement. Accordingly, this Agreement shall be construed by its “four corners”
                            without regard to any rule of construction, whether created by rule of law or legal decision, in the event an ambiguity
                            arises.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            k.{'    '}
                            <Text style={[styles.indent]}>Headings:</Text> The paragraph headings herein are used only for the purpose of convenience
                            and shall not be deemed to limit the subject of the sections or paragraphs of this Agreement or to be considered in their
                            construction.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            l.{'    '}
                            <Text style={[styles.indent]}>Recitals:</Text> Any recitals in this Agreement are represented by the Parties to be
                            accurate and constitute a part of this Agreement to be binding on the Parties.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            m.{'    '}
                            <Text style={[styles.indent]}>Scope of Agreement:</Text> This Agreement incorporates all of the covenants and
                            understandings between Mineral Owner and Company concerning the subject matter hereof and such agreements, covenants, and
                            understandings are merged into this Agreement. No prior agreement or understanding between Mineral Owner and Company shall
                            be valid or enforceable unless expressly embodied in this Agreement.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            n.{'    '}
                            <Text style={[styles.indent]}>Amendment:</Text> This Agreement shall not be altered, changed or amended except by written
                            instrument executed by both, Mineral Owner and Company.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            o.{'    '}
                            <Text style={[styles.indent]}>Recording:</Text> Company may record this Agreement or a Memorandum of Agreement in the real
                            property records of the county where the Property is located, but may remove the attached Exhibit B hereto and/or its
                            consideration terms before any such recording
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            p.{'    '}
                            <Text style={[styles.indent]}>Severability:</Text> If any provision of this Agreement is determined, in a final and
                            unappealable decision by a court of competent jurisdiction, to be invalid, void or unenforceable, the remaining provisions
                            hereof shall remain in full force and effect, unimpaired by the determination.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            q.{'    '}
                            <Text style={[styles.indent]}>Mortgage Provisions:</Text> Company shall have the right at any time to mortgage, pledge,
                            encumber, and/or collaterally assign to any entity (each, a “Mortgagee”) all or any part of Company’s interest under this
                            Agreement and the rights and obligations created by this Agreement without the consent of Mineral Owner. Each Mortgagee
                            shall have the right to do any act or thing required to be performed by Company under this Agreement, and any such act or
                            thing performed by a Mortgagee shall be as effective to prevent a default under this Agreement and/or a forfeiture of any
                            of Company’s rights under this Agreement as if done by Company itself.
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.firstLvl,
                            {
                                marginTop: 16,
                            },
                        ]}
                        wrap={true}
                    >
                        <Text style={[styles.fontNormal, styles.text]} wrap={true}>
                            r.{'    '}
                            <Text style={[styles.indent]}>Multiple Mineral Owners:</Text> If Mineral Owner consists of more than one person or entity,
                            then each reference herein to “Mineral Owner” shall include each person and entity signing this Agreement as or on behalf
                            of Mineral Owner, and the liability of each such person and entity shall be joint and several. In the event that this
                            Agreement is not executed by one or more of the persons or entities comprising Mineral Owner herein, then this Agreement
                            shall nonetheless be effective, and shall bind all those persons and entities who have signed this Agreement.
                        </Text>
                    </View>

                    <Text style={[styles.fontNormal, styles.indent, styles.mt1, styles.text, { textAlign: 'center', marginTop: 30 }]}>
                        [End of Agreement; Signature and Acknowledgement Pages Follow]
                    </Text>

                    <Text
                        style={styles.pageNumbers}
                        render={({ pageNumber }) => {
                            return `${pageNumber}`;
                        }}
                        fixed={true}
                    />
                </Page>

                <Page size="LEGAL" style={styles.page}>
                    <Text style={[styles.exhibitHeading, styles.bold]}>Exhibit A</Text>
                    <Text style={[styles.mt1, { textAlign: 'center', fontSize: '11pt' }]}>Legal Description of Property</Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        {PropertyUtil.SafeGet(() => rowValues.legalDescription, 'LEGAL DESCRIPTION')}
                    </Text>
                    <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                </Page>

                <Page size="LEGAL" style={styles.page}>
                    <Text style={[styles.exhibitHeading, { color: 'red' }]}>(REMOVE THIS PAGE BEFORE RECORDING IN ANY REAL PROPERTY RECORDS)</Text>

                    <Text style={[styles.exhibitHeading, styles.mt1, styles.bold]}>Exhibit B</Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.center]}>Payment Terms</Text>

                    <Text style={[styles.fontNormal, styles.mt2, styles.text, styles.firstLvl]}>
                        1.{'    '}As consideration for this Agreement Company shall pay Mineral Owner the amounts set forth below:
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.secondLvl]}>
                        a.{'    '}Company shall pay a signing fee in the amount of{' '}
                        <Text style={[styles.bold]}>${PropertyUtil.SafeGet(() => rowValues.surfaceWaiverHolds[0].bonusPaid, 'BONUS')}</Text>.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.secondLvl]}>
                        b.{'    '}b. Upon start of Construction Phase, there will be an additional payment made to Mineral Owner in the amount of{' '}
                        <Text style={[styles.bold]}>
                            ${PropertyUtil.SafeGet(() => rowValues.surfaceWaiverHolds[0].additionalConsideration, 'ADDITIONAL CONSIDERATION')} per Net
                            Mineral Acre owned
                        </Text>
                        .
                    </Text>

                    <Text style={[styles.fontNormal, styles.mt2, styles.text, styles.firstLvl]}>
                        2.{'    '}Payments shall be made to Mineral Owner at the address provided in Section 7 a. of this Agreement.
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt2, styles.text, styles.firstLvl]}>
                        3.{'    '}Payments made to Mineral Owner as provided in this Exhibit B are full and final compensation and consideration to
                        Mineral Owner, including without limitation, loss of profits or revenue and losses of rent, business opportunities and the
                        like that may result from a loss of use of the Mineral Rights
                    </Text>
                    <Text style={[styles.fontNormal, styles.mt2, styles.text, styles.firstLvl]}>
                        4.{'    '}The terms of this Exhibit B are to remain strictly, totally, and completely confidential and any breach of the terms
                        of this paragraph shall expose Mineral Owner to, and entitle Company to seek, all equitable relief as well as monetary damages
                        from Mineral Owner.
                    </Text>

                    <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                </Page>

                {/* <Page size="LEGAL" style={styles.page}>
                    <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                </Page> */}

                {/* <Page size="LEGAL" style={styles.page}>

                    <Text style={[styles.fontNormal, styles.mt2, styles.text]}>
                        IN TESTIMONY WHEREOF, I sign the ____ day of ___________________, 20____,
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt4, styles.text]}>
                        LESSOR:
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt4, styles.text]}>
                        ______________________________________________
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt1, styles.text]}>
                        {PropertyUtil.SafeGet(() => leaseValues.lessor.name, 'LESSOR')}
                    </Text>

                    <Text style={[styles.fontNormal, styles.center, styles.mt3, styles.h2]}>
                        (ACKNOWLEDGMENT)
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        STATE OF ________________________
                         </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        COUNTY OF ________________________
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        Before me, the udnersigned, a Notary Public, in and for said county and State, on this ____ day of ____________________, 20___, personally appeared ____________________, an
                        individual, personally known to me
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt1]}>
                        to be the identical person who executed the within and foregoinginstrument, and acknowledged to me that he executed the same as his free and voluntary act and deed, for the
                        use and purposes therein set forth.
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt1]}>
                        Notary Public
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        Print Name _______________________________________
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        My Commission expires: ________________________
                        </Text>

                    <Text style={[styles.fontNormal, styles.mt3]}>
                        Commission Number: ________________________
                        </Text>

                    <Text
                        style={styles.pageNumbers}
                        render={({ pageNumber }) => (
                            `${pageNumber}`
                        )}
                        fixed={true}
                    />

                    {this.signatureBlocks()}
                </Page> */}

                {PropertyUtil.SafeGet(() => rowValues.acknowledgements.length > 0) && (
                    <Page size="LEGAL" style={styles.page}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', rowGap: '5rem' }}>
                            {this.displaySignatureBlocks()}
                        </div>
                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>
                )}
                {PropertyUtil.SafeGet(() => rowValues.acknowledgements.length > 0) && (
                    <Page size="LEGAL" style={styles.page}>
                        <Text style={[styles.acknowledgementHeading, styles.mt3]}>(ACKNOWLEDGEMENT)</Text>
                        {this.displayAcknowledgements()}
                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>
                )}

                {PropertyUtil.SafeGet(() => rowValues.adHocClauses.length > 0) && (
                    <Page size="LEGAL" style={styles.page}>
                        <Text style={styles.exhibitHeading}>Exhibit C</Text>
                        <Text style={[styles.fontNormal, styles.mt3, styles.h2]}>Additional Provisions</Text>

                        {this.additionalProvisions()}
                        {this.adhocProvisions()}

                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>
                )}
            </Document>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/LeaseDocuments/SurfaceWaiverLeaseDocs/PalladiumEnergy.tsx